import React, { useRef } from 'react';
import { uploadPDF } from '../services/api';

interface ResumeUploadProps {
  resumeText: string;
  onResumeChange: (text: string) => void;
  onUploadSuccess?: (text: string) => void;
  onUploadError?: (error: string) => void;
}

const ResumeUpload: React.FC<ResumeUploadProps> = ({ 
  resumeText, 
  onResumeChange, 
  onUploadSuccess,
  onUploadError 
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      onUploadError?.('Please select a PDF file');
      return;
    }

    try {
      const result = await uploadPDF(file);
      if (result.success) {
        onResumeChange(result.extracted_text);
        onUploadSuccess?.(result.extracted_text);
      } else {
        onUploadError?.(result.error || 'Failed to extract text from PDF');
      }
    } catch (error: any) {
      onUploadError?.(error.message || 'Failed to upload PDF');
    }
  };

  return (
    <div>
      <h2>📄 Resume Input</h2>
      
      {/* PDF Upload Section */}
      <div className="form-group">
        <label className="form-label">
          Upload PDF Resume:
        </label>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <input
            type="file"
            accept=".pdf"
            onChange={handleFileUpload}
            ref={fileInputRef}
            style={{ display: 'none' }}
          />
          <button 
            className="btn btn-secondary"
            onClick={() => fileInputRef.current?.click()}
          >
            📁 Upload PDF
          </button>
          <span style={{ fontSize: '14px', color: '#666' }}>
            Or paste text below
          </span>
        </div>
      </div>

      {/* Text Input Section */}
      <div className="form-group">
        <label className="form-label">
          Resume Text:
        </label>
        <textarea
          className="form-control textarea"
          value={resumeText}
          onChange={(e) => onResumeChange(e.target.value)}
          placeholder="Enter your resume content here or upload a PDF above..."
        />
      </div>
      
      <div className="alert alert-info">
        <strong>💡 Tip:</strong> You can either upload a PDF resume or paste the text directly. 
        The AI will analyze and improve it based on the job description.
      </div>
    </div>
  );
};

export default ResumeUpload;
